import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-user-photos-modal',
  templateUrl: './page-user-photos-modal.component.html',
  styleUrls: ['./page-user-photos-modal.component.scss']
})
export class PageUserPhotosModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
